import React, { useState } from "react";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { BrandLogo } from "../components/BrandLogo";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    const res = await login(email.trim(), password);
    setBusy(false);
    if (res.ok) nav("/admin");
    else setErr(res.error);
  };

  return (
    <div className="min-h-screen grid md:grid-cols-5" style={{ background: "var(--bg-soft)" }}>
      <div className="md:col-span-3 hidden md:flex flex-col justify-between p-12 relative overflow-hidden" style={{ background: "var(--brand-navy)" }}>
        <Link to="/" className="relative z-10">
          <BrandLogo size={44} variant="light" subline="Panel administrativo" iconBg="rgba(255,255,255,0.04)"/>
        </Link>

        <div className="text-white relative z-10">
          <div className="text-[11px] uppercase tracking-[0.2em] font-bold mb-3" style={{ color: "var(--brand-accent)" }}>
            Gestión centralizada
          </div>
          <h1 className="text-4xl font-extrabold tracking-tight leading-tight max-w-sm" style={{ fontFamily: "Manrope" }}>
            Cotizaciones, pólizas y renovaciones en un solo lugar.
          </h1>
          <p className="mt-4 opacity-75 max-w-sm">
            Accede al panel para revisar solicitudes, gestionar clientes y monitorear estados de todas las pólizas activas.
          </p>
        </div>

        <div className="text-white/50 text-xs relative z-10">© {new Date().getFullYear()} Mi Comunidad Segura SpA</div>

        {/* decorative */}
        <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full opacity-20" style={{ background: "var(--brand-accent)" }}></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full opacity-10" style={{ background: "white" }}></div>
      </div>

      <div className="md:col-span-2 flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
          <div className="flex items-center gap-2 mb-8">
            <div className="w-10 h-10 rounded-md flex items-center justify-center" style={{ background: "var(--brand-navy)" }}>
              <Lock size={18} color="white" />
            </div>
            <h2 className="text-2xl font-bold tracking-tight" style={{ fontFamily: "Manrope" }}>Iniciar sesión</h2>
          </div>

          <div className="space-y-4">
            <div>
              <label className="field-label">Email</label>
              <input className="field-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@micomunidadsegura.cl" required data-testid="login-email"/>
            </div>
            <div>
              <label className="field-label">Contraseña</label>
              <input className="field-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password"/>
            </div>
          </div>

          {err && <div className="mt-4 p-3 rounded-md text-sm border" style={{ borderColor: "rgba(211,47,47,0.25)", background: "rgba(211,47,47,0.05)", color: "#9a1919" }} data-testid="login-error">{err}</div>}

          <button type="submit" className="btn-primary w-full justify-center mt-6" disabled={busy} data-testid="login-submit">
            {busy ? "Ingresando..." : "Ingresar"}
          </button>

          <Link to="/" className="block text-center text-sm mt-6 nav-link" style={{ color: "var(--text-muted)" }}>← Volver al sitio</Link>
        </form>
      </div>
    </div>
  );
}
